import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import styles from './Navigation.module.css';
import { HomeIcon, SearchIcon, BookIcon, UserIcon, SettingsIcon } from './Icons';

const Navigation = () => {
  const { user } = useAuth();
  const navItems = [
    {
      path: '/',
      label: '首页',
      icon: <HomeIcon size={20} />
    },
    {
      path: '/discover',
      label: '发现',
      icon: <SearchIcon size={20} />
    },
    {
      path: '/history',
      label: '学习',
      icon: <BookIcon size={20} />
    },
    {
      path: '/profile',
      label: '我的',
      icon: <UserIcon size={20} />
    }
  ];

  return (
    <nav className={styles.navigation}>
      <div className={styles.navContainer}>
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) => 
              `${styles.navItem} ${isActive ? styles.navItemActive : ''}`
            }
            end={item.path === '/'}
          >
            <span className={styles.navIcon}>{item.icon}</span>
            <span className={styles.navLabel}>{item.label}</span>
          </NavLink>
        ))}
        
        {/* 管理员入口 - 只对管理员显示 */}
        {user?.is_admin && (
          <NavLink
            to="/admin"
            className={({ isActive }) => 
              `${styles.navItem} ${styles.adminItem} ${isActive ? styles.navItemActive : ''}`
            }
          >
            <span className={styles.navIcon}><SettingsIcon size={20} /></span>
            <span className={styles.navLabel}>管理</span>
          </NavLink>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
